import { func_validation } from "./func_validation";

export const func_intl = {

    flattenMessages,

	formatMessageSimple,
	formatMessageObject,
	
	formatDefinedMessageSimple,
	tryFormatDefinedMessageSimple,

	formatNumber,
	formatNumberPercent,
	formatNumberCurrency,
	formatNumberCurrencyWithSymbol,
	formatNumberCurrencyWithCode,
	formatNumberCurrencyWithName,
	
	formatNumberCustom,

};

// flattenMessages from react-intl
function flattenMessages(nestedMessages, prefix = "") {
    return Object.keys(nestedMessages).reduce((messages, key) => {
        let value       = nestedMessages[key];
        let prefixedKey = prefix ? `${prefix}.${key}` : key;

        if (typeof value === "string") {
            messages[prefixedKey] = value;
        } else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
        }

        return messages;
    }, {});
}

function formatMessageSimple(props, id) {
	if (func_validation.isObjectNotEmpty(props) && 
		func_validation.isStringTrimNotEmpty(id))
		return props.intl.formatMessage({ id: id });
	return "";
}

function formatMessageObject(props, obj, opts) {
	if (func_validation.isObjectNotEmpty(props) && 
		func_validation.isObjectNotEmpty(obj)) {
		
		if (func_validation.isObjectNotEmpty(opts)) {
			return props.intl.formatMessage(obj, opts);
		} else return props.intl.formatMessage(obj);
	}
	return "";
}

function formatDefinedMessageSimple(props, definedMessage, id, opts) {
	if (func_validation.isObjectNotEmpty(props) && 
		func_validation.isObjectNotEmpty(definedMessage) && 
		func_validation.isStringTrimNotEmpty(id)) {
		
		if (func_validation.isObjectNotEmpty(opts)) {
			return props.intl.formatMessage(definedMessage[id], opts);
		} else return props.intl.formatMessage(definedMessage[id]);

	}
	return "";
}

function tryFormatDefinedMessageSimple(props, definedMessage, id, opts) {
	let msg = id;
	try { msg = formatDefinedMessageSimple(props, definedMessage, id, opts);

		// If message definition property value is empty, function above retrieves "";
		// thus, set back to message back to id
		if (func_validation.isStringTrimNotEmpty(id) && 
			!func_validation.isStringTrimNotEmpty(msg)) {
			msg = id;
		}

	} catch (e) { msg = id; }

	return msg;
}

function formatNumber(props, val, opts) {
	if (func_validation.isObjectNotEmpty(props) && 
		func_validation.isNumberValid(val)) {
		
		if (func_validation.isObjectNotEmpty(opts)) {
			return props.intl.formatNumber(val, opts);
		} else return props.intl.formatNumber(val);
	}
	return "";
}

function formatNumberPercent(props, val, opts) {
	if (func_validation.isObjectNotEmpty(opts)) 
		return formatNumber(props, val, { style: "percent", ...opts });
	return formatNumber(props, val, { style: "percent" });
}

function formatNumberCurrency(props, val, currencyType, opts) {
	if (func_validation.isStringTrimNotEmpty(currencyType)) {
		if (func_validation.isObjectNotEmpty(opts)) {
			return formatNumber(props, val, { style: "currency", currency: currencyType, ...opts });
		} else return formatNumber(props, val, { style: "currency", currency: currencyType });
	}
	return "";
}

function formatNumberCurrencyWithSymbol(props, val, currencyType, opts) {
	if (func_validation.isObjectNotEmpty(opts)) 
		return formatNumberCurrency(props, val, currencyType, { currencyDisplay: "symbol", ...opts });
	return formatNumberCurrency(props, val, currencyType, { currencyDisplay: "symbol" });
}

function formatNumberCurrencyWithCode(props, val, currencyType, opts) {
	if (func_validation.isObjectNotEmpty(opts)) 
		return formatNumberCurrency(props, val, currencyType, { currencyDisplay: "code", ...opts });
	return formatNumberCurrency(props, val, currencyType, { currencyDisplay: "code" });
}

function formatNumberCurrencyWithName(props, val, currencyType, opts) {
	if (func_validation.isObjectNotEmpty(opts)) 
		return formatNumberCurrency(props, val, currencyType, { currencyDisplay: "name", ...opts });
	return formatNumberCurrency(props, val, currencyType, { currencyDisplay: "name" });
}

function formatNumberCustom(props, val, customOpts, formatNumberOpts) {
	let num = formatNumber(props, val, formatNumberOpts);
	if (func_validation.isStringTrimNotEmpty(num)) {
		
		// Custom Options
		if (func_validation.isObjectNotEmpty(customOpts)) {
			
			// Currency Symbol
			let currencySymbol = func_validation.getObjectPropertyValue(customOpts, "currencySymbol", "");
			if (func_validation.isStringTrimNotEmpty(currencySymbol)) num = currencySymbol + num;

			// Prefix
			let prefix = func_validation.getObjectPropertyValue(customOpts, "prefix", "");
			if (func_validation.isStringTrimNotEmpty(prefix)) num = prefix + num;

			// Suffix
			let suffix = func_validation.getObjectPropertyValue(customOpts, "suffix", "");
			if (func_validation.isStringTrimNotEmpty(suffix)) num = num + suffix;

		}

		return num;
	}
	return "";
}


